export const CHECKBOX_CSS_VARS_PREFIX = 'checkbox';
export const CHECKBOX_CUSTOMISABLE_PARAMS = ['checkedColor'];
